const calFontStyle = (
	weight,
	size,
	lineHeight = 'normal',
	letterSpacing = 'normal'
) => {
	return `
        font-family: "NotoSansKR", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-weight: ${weight};
        font-size: ${size};
        line-height: ${lineHeight};
        letter-spacing: ${letterSpacing};
    `
}

const font = {
	tiny: calFontStyle('400', '8px'),
	extra_small: calFontStyle('400', '12px'),
	extra_small_bold: calFontStyle('700', '12px'),
	small: calFontStyle('400', '16px'),
	small_bold: calFontStyle('700', '16px'),
	medium: calFontStyle('400', '20px'),
	medium_bold: calFontStyle('700', '20px'),
	large: calFontStyle('400', '24px'),
	large_bold: calFontStyle('700', '24px'),
	extra_large: calFontStyle('400', '32px'),
	heading: calFontStyle('700', '48px'),
}

const color = {
	// Basic List
	white: '#FFFFFF',
	grey1: '#EEF0F2',
	grey2: '#DFDFE7',
	grey3: '#B2B2B2',
	grey4: '#8D8D8D',
	black: '#1F2024',

	// State List
	major: '#ED3241',
}

const breakpoints = {
	mobile: '768px',
	tablet: '1024px',
	desktop: '1200px',
}

const theme = {
	font,
	color,
	breakpoints,
}

export default theme
